import { AdminEnquiry } from "./AdminEnquiry";

export class AdminEnquiryResponse{
    public adminEnquiryList: AdminEnquiry[] = [];
}